import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/ActivityRecords.requests'
import {
    ActivityRecord,
} from '../ActivityRecords/activityRecords.types'

const useGetActivityRecord = (id: number) => {
    return useRequest<ActivityRecord>({
        key: RequestKeys.getActivityRecord,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}

export default useGetActivityRecord
